import React, {useEffect} from 'react';
import {cn} from "@/lib/utils/cn";
import {useAuth} from "@/provider/AuthProvider";
import {getAccessToken} from "@/lib/services/tokenService";

import {AuroraBackground} from "@/components/ui/aurora-background";
import {useGetCurrentUser} from "@/api/auth";
import AuthSocialNetworkSection from "@/pages/auth/_section/AuthSocialNetworkSection";
import RenderIf from "@/components/render-if";

function AuthLayout({className, showSocialNetworks = false, children}) {

    const token = getAccessToken()

    const {setUser} = useAuth()

    const {data: userData} = useGetCurrentUser({enabled: !!token})

    useEffect(() => {
        if (!userData?.data) return;
        setUser(userData?.data)
    }, [userData])

    return (
        <AuroraBackground>
            <div className="flex items-center justify-center">
                <div className={'md:min-w-[450px] md:max-w-[450px]'}>
                    <div className={cn("flex flex-col gap-6", className)}>
                        {children}
                    </div>
                    <RenderIf condition={showSocialNetworks}>
                        <AuthSocialNetworkSection/>
                    </RenderIf>
                </div>
            </div>
        </AuroraBackground>

    );
}

export default AuthLayout;